<template lang="pug">
  .state-count-card.sombra
    .state-count-card-icon-container(v-if="icon" :style="`background-color: ${color}`")
      .material-icons-outlined(style="font-size: 28px;") {{ icon }}
    .state-count-card-body
      div(style="font-size: 13px;") {{ stateName }}
      .value-row(v-if="inlineSubLabel")
        div.value-main {{ mainValue }}{{ unit }}
        div.value-inline(v-if="subLabel") {{ subLabel }}
      template(v-else)
        div(style="font-size: 25px; font-weight: 700;") {{ mainValue }}{{ unit }}
        div.total-label(v-if="subLabel") {{ subLabel }}
</template>

<script>
export default {
  name: 'StatusSummaryCard',
  props: {
    color: {
      type: String,
      default: 'var(--primary)'
    },
    stateName: {
      type: String,
      default: 'Estado'
    },
    // Valor principal a mostrar en grande
    mainValue: {
      type: [String, Number],
      default: 0
    },
    // Unidad que se muestra junto al valor principal (e.g. '%', 'paq.', '')
    unit: {
      type: String,
      default: '%'
    },
    // Texto pequeño bajo el valor principal (e.g. '5 total')
    subLabel: {
      type: String,
      default: ''
    },
    // Si es true, el subLabel se muestra en la misma fila que el valor principal
    inlineSubLabel: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.state-count-card {
  background-color: white;
  display: flex;
  height: 85px;
  &-body {
    font-weight: 700;
    color: #495057;
    display: flex;
    padding: 8px 12px;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
  }
  &-icon-container {
    color: white;
    display: flex;
    width: 70px;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
}

.total-label {
  font-size: 12px;
  font-weight: 400;
  color: #6c757d;
}

.value-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.value-main {
  font-size: 25px;
  font-weight: 700;
  line-height: 1.2;
}

.value-inline {
  font-size: 16px;
  font-weight: 600;
  color: #6c757d;
}
</style>
